import { useContext } from 'react';

import { FormEditorHeaderSlotContext } from './constants';

// Null outside a page that hosts the form header row, so the row renders in place.
const useFormEditorHeaderSlot = () => useContext(FormEditorHeaderSlotContext);

export { FormEditorHeaderSlotContext };
export default useFormEditorHeaderSlot;
